// BTSelectBox Component
import { Select, MenuItem, SelectChangeEvent } from '@mui/material';

interface BTSelectBoxProps {
  options: { label: string; value: string }[];
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  disabled?: boolean;
  readOnly?: boolean;
  sx?: object;
  width?: string | number;
}

export const BTSelectBox: React.FC<BTSelectBoxProps> = ({ options, value, onChange, disabled = false, readOnly = false, sx = {}, width }) => {
  return (
    <Select
      value={value}
      onChange={readOnly ? () => {} : onChange}
      fullWidth
      size="small"
      disabled={disabled || readOnly}
      sx={{
        width: width ? (typeof width === 'number' ? `${width}px` : width) : '100%',
        height: '44px',
        borderRadius: '4px',
        backgroundColor: 'white',
        fontSize: '16px',
        color: '#232d42',
        border: '1px solid #adb5bd',
        '& .MuiSelect-select': {
          padding: '10px',
        },
        ...sx,
      }}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};